
// Function to show the mini-cart popup
const miniCartPopup = document.querySelector('.cart-wrapper');
const miniCartItemsList = document.getElementById('cart-items-container');
let selectedVariant;
let minicart = document.getElementById('minicart');
let miniCartVisible = false;

function openMiniCart() {
  updateMiniCart();
  if (!miniCartVisible) {
    miniCartPopup.style.display = 'flex';
    gsap.to(miniCartPopup, {
      opacity: 1,
      duration: 0.3,
      onComplete: function () {
        miniCartVisible = true;
      }
    });
  }
}

function closeMiniCart() {
  if (miniCartVisible) {
    gsap.to(miniCartPopup, {
      opacity: 0,
      onComplete: function () {
        miniCartPopup.style.display = 'none';
        miniCartVisible = false;
      }
    });
  }
}

minicart.addEventListener('click', function (event) {
  event.preventDefault();
  openMiniCart();
});

document.addEventListener('click', function (event) {
  if (miniCartVisible && !miniCartPopup.contains(event.target) && event.target.id !== 'minicart') {
    closeMiniCart();
  }
});

document.addEventListener('click', function (event) {
  const cartContainer = document.querySelector('.cart-container');
  if (miniCartVisible && !cartContainer.contains(event.target)) {
    closeMiniCart();
  }
});


function closeMiniCartOnClickOutside() {
  document.addEventListener('click', function (event) {
    if (miniCartVisible && !miniCartPopup.contains(event.target)) {
      closeMiniCart();
      miniCartVisible = false;
    }
  });
}


closeMiniCartOnClickOutside();

function updateMiniCart() {

  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      miniCartItemsList.innerHTML = '';

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: cartData.currency,
        maximumFractionDigits: 2,

      });
      let total = 0;
      console.log('Cart data:', cartData);
      if (cartData.items.length > 0) {
        document.querySelector('.text-block-16').style.display = 'none';
      }
      else {
        document.querySelector('.text-block-16').style.display = 'block';
      }


      cartData.items.forEach(item => {
        const listItem = document.createElement('li');
        const descriptionItem = document.createElement('div');
        const image = document.createElement('img');
        image.src = item.featured_image.url;
        image.alt = item.featured_image.alt;
        listItem.appendChild(image);


        const titleItem = document.createElement('h4');
        titleItem.textContent = item.product_title;
        descriptionItem.appendChild(titleItem);


        const priceItem = document.createElement('p');

        const formattedPrice = formatter.format(item.price / 100);
        priceItem.textContent = `${formattedPrice}`;
        descriptionItem.appendChild(priceItem);



        const sizeItem = document.createElement('p');
        sizeItem.textContent = `${item.variant_title}`;
        descriptionItem.appendChild(sizeItem);
        const removeButton = document.createElement('button');
        removeButton.textContent = 'Eliminar artículo';
        removeButton.addEventListener('click', function () {
          removeCartItem(item.id);
        });
        descriptionItem.appendChild(removeButton);

        const quantityInput = document.createElement('input');
        quantityInput.classList.add('cart-quantity');

        quantityInput.type = 'number';
        quantityInput.value = item.quantity;
        quantityInput.addEventListener('input', function () {
          updateCartItemQuantity(item.id, parseInt(quantityInput.value, 10));
        });



        descriptionItem.classList.add('cart-item-description');
        listItem.classList.add('cart-item-gold');
        listItem.appendChild(descriptionItem);
        listItem.appendChild(quantityInput);
        miniCartItemsList.appendChild(listItem);
        total += item.quantity * item.price;
      });

      const totalElement = document.querySelector('.mini-cart-total');
      totalElement.textContent = formatter.format(total / 100);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
}

function removeCartItem(itemId) {

  fetch(`/cart/change.js?id=${itemId}&quantity=0`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(cartData => {

      updateMiniCart();
    })
    .catch(error => {
      console.error('Error removing cart item:', error);
    });
}

function updateCartItemQuantity(itemId, newQuantity) {

  fetch(`/cart/change.js?id=${itemId}&quantity=${newQuantity}`)
    .then(response => response.json())
    .then(cartData => {

      updateMiniCart();
    })
    .catch(error => {
      console.error('Error updating cart item quantity:', error);
    });
}



function removeFromCart(itemId) {

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: itemId,
      quantity: 0,
    }),
  })
    .then(response => response.json())
    .then(data => {

      updateMiniCart();
      console.log('Item removed from cart:', data);
    })
    .catch(error => {
      console.error('Error removing item from cart:', error);
    });
}




document.addEventListener('change', function (event) {
  if (event.target.name === 'variant' && event.target.checked) {
    selectedVariant = event.target.value;
    console.log('Selected variant ID:', selectedVariant);
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const selectedVariant = document.querySelector('input[name="variant"]:checked');
  if (!selectedVariant) {

    const firstVariantInput = document.querySelector('input[name="variant"]');
    if (firstVariantInput) {
      firstVariantInput.checked = true;
      const firstVariantId = firstVariantInput.value;
      showPrice(firstVariantId);

    }
  }
});
function addToCart(productId) {

  const selectedVariant = document.querySelector('input[name="variant"]:checked');
  if (!selectedVariant) {
    console.log('Please select a variant before adding to the cart.');
    return;

  }

  const selectedVariantId = selectedVariant.value;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: selectedVariantId,
      quantity: 1,
    }),
  })
    .then(response => response.json())
    .then(data => {
      updateMiniCart();
      console.log('Item added to cart:', data);
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
    });

  openMiniCart();
}



const addToCartButtons = document.querySelectorAll('.add-to-cart-gold');

addToCartButtons.forEach(function (addToCartButton) {
  addToCartButton.addEventListener('click', function (event) {
    event.preventDefault();

    var productId = document.getElementById('addToCartForm_{{ product.id }}').getAttribute('data-product-id');
    const quantity = addToCartButton.getAttribute('data-quantity');

    addToCart(productId, quantity);
  });
});


